import axios from 'axios'
import { CONFIG_API } from 'constants/ResourcesConstants'

export const ConfigAPI = axios.create({ baseURL: CONFIG_API })

export const getConfig = (config) => {
  return ConfigAPI.get(`${config}`)
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/navConfig/api.js